namespace Areas.Reviewers {
    "use strict";


    export function sendInsuranceEmail() {
        const expiringGrid = $("#InsuranceGrid").dxDataGrid("instance");

        var vendorIds = expiringGrid.getSelectedRowKeys();

        var data: any = {
            SelectedItems: vendorIds
        };

        sendRequest("/Reviewers/ExpiringInsurance/SendExpiringInsuranceEmail", JSON.stringify(data), "PUT");
    }
}
